module.exports = __webpack_public_path__ + "img/Ergonomist - Maria Gonzalez-1.305c0b99.png";